import React from "react";
import AntdSlider, {SliderSingleProps, SliderRangeProps} from 'antd/lib/slider';
import {withError} from '@fishx/tracker';

interface SProps {
    forwardedRef?: any;
};
export const Slider: React.FC<(SliderSingleProps | SliderRangeProps) & SProps> = (props) => {
    const { forwardedRef, ...rest } = props;
    return (
        <AntdSlider ref={forwardedRef} {...rest} />
    )
}

export default withError(Slider,{forwardRef:true})





// WEBPACK FOOTER //
// ./src/components/slider/index.tsx